import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="w-full bg-white px-5 py-14 sm:px-6 sm:py-20" data-id="element-119" data-mp="1o2vjmvsbez9q">
      <div className="mx-auto w-full max-w-2xl" data-id="element-120" data-mp="223oejhmj3wdd">
        <div className="rounded-3xl border-2 border-ofm-200 bg-cream p-6 text-center sm:p-9" data-id="element-121" data-mp="221by58wf5u2f">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-ofm-600" data-id="element-122" data-mp="1x54trkjo8qml">
            <ShieldCheckIcon className="h-9 w-9 text-white" aria-hidden="true" data-id="element-123" data-mp="19co8l14n0ij2" />
          </div>
          <p className="mt-4 text-[12px] font-extrabold uppercase tracking-[0.16em] text-ofm-600" data-id="element-124" data-mp="14dl1lb53k28g">
            Tu compra está completamente protegida
          </p>
          <h2 className="mt-2 font-display text-[26px] font-extrabold leading-tight text-ofm-900 sm:text-4xl" data-id="element-125" data-mp="1ecspgs9gjf9t">
            Garantía incondicional de 7 días
          </h2>

          <p className="mt-5 text-[15px] leading-relaxed text-ofm-900/75" data-id="element-126" data-mp="lpg6es2i9pl9">
            Prueba el Sistema OFM. Revísalo con calma. Explora cada tomo.
          </p>
          <p className="mt-3 text-[15px] leading-relaxed text-ofm-900/75" data-id="element-127" data-mp="oxfb4c17yttm">
            Si durante los próximos siete días sientes que el sistema no te ayuda a
            tomar decisiones clínicas con mayor seguridad, solo envíanos un correo y
            te devolveremos el 100% de tu dinero.
          </p>
          <p className="mt-4 text-[15px] font-bold leading-relaxed text-ofm-900" data-id="element-128" data-mp="12sr4aezq8c8f">
            Sin formularios complicados. Sin explicaciones. Sin riesgos.
            <br data-id="element-129" data-mp="b0s41gfjyn9z" />
            Toda la responsabilidad es nuestra.
          </p>
        </div>

        <CTAButton className="mt-8" label="🦷 QUIERO PROBARLO SIN RIESGO" subline="7 días de garantía · Devolución del 100%" data-id="element-130" data-mp="f0ako00ccc70" />
      </div>
    </section>;
}